import banner from "assets/img/profile/banner.png";

const Banner = ({ profileData }: { profileData: any }) => {
  const initials =
    (profileData?.first_name?.charAt(0) ?? "").toUpperCase() +
    (profileData?.last_name?.charAt(0) ?? "").toUpperCase();

  return (
    <div className="bnr-card">
      <div className="bnr-cover" style={{ backgroundImage: `url(${banner})` }}>
        <div className="bnr-cover-overlay" />
        <div className="bnr-avatar">
          <span className="bnr-avatar-initials">{initials || "?"}</span>
        </div>
      </div>

      <div className="bnr-info">
        <h3 className="bnr-name">{profileData?.first_name} {profileData?.last_name}</h3>
        <span className="bnr-role">{profileData?.role || "—"}</span>
      </div>

      <div className="bnr-stats">
        {[
          { label: "Email", value: profileData?.email || "—", icon: (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          )},
          { label: "2FA", value: profileData?.auth_2fa ? "Enabled" : "Disabled", icon: (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          )},
        ].map((s) => (
          <div key={s.label} className="bnr-stat">
            <div className="bnr-stat-icon">{s.icon}</div>
            <div className="bnr-stat-text">
              <p className="bnr-stat-label">{s.label}</p>
              <p className={`bnr-stat-value${s.label === "2FA" ? (profileData?.auth_2fa ? " bnr-stat-value--green" : " bnr-stat-value--red") : ""}`}>
                {s.value}
              </p>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .bnr-card { font-family:'Plus Jakarta Sans',sans-serif; background:#fff; border:1px solid #e2e8f0; border-radius:18px; overflow:hidden; box-shadow:0 2px 8px rgba(15,23,42,.06); }

        .bnr-cover { position:relative; height:100px; background-size:cover; background-position:center; flex-shrink:0; }
        .bnr-cover-overlay { position:absolute; inset:0; background:linear-gradient(135deg,rgba(29,78,216,.4),rgba(124,58,237,.3)); }
        .bnr-avatar { position:absolute; bottom:-28px; left:50%; transform:translateX(-50%); width:56px; height:56px; border-radius:50%; background:linear-gradient(135deg,#1d4ed8,#2563eb); border:3px solid #fff; display:flex; align-items:center; justify-content:center; box-shadow:0 4px 14px rgba(37,99,235,.3); }
        .bnr-avatar-initials { font-size:18px; font-weight:800; color:#fff; letter-spacing:-0.5px; }

        .bnr-info { padding:40px 20px 16px; text-align:center; border-bottom:1px solid #f1f5f9; }
        .bnr-name { font-size:16px; font-weight:800; color:#0f172a; letter-spacing:-0.3px; margin-bottom:6px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
        .bnr-role { display:inline-block; font-size:11.5px; font-weight:700; color:#2563eb; background:#eff6ff; border:1.5px solid #bfdbfe; border-radius:8px; padding:3px 10px; text-transform:uppercase; letter-spacing:0.4px; }

        .bnr-stats { padding:14px 18px; display:flex; flex-direction:column; gap:10px; }
        .bnr-stat { display:flex; align-items:flex-start; gap:10px; padding:10px 12px; background:#f8fafc; border:1px solid #f1f5f9; border-radius:11px; min-width:0; }
        .bnr-stat-icon { width:30px; height:30px; border-radius:8px; background:linear-gradient(135deg,#eff6ff,#dbeafe); border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; color:#2563eb; flex-shrink:0; margin-top:1px; }
        .bnr-stat-text { flex:1; min-width:0; }
        .bnr-stat-label { font-size:11px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:0.4px; margin-bottom:2px; }
        .bnr-stat-value { font-size:13px; font-weight:600; color:#0f172a; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; margin-top:0 !important; }
        .bnr-stat-value--green { color:#16a34a; }
        .bnr-stat-value--red   { color:#dc2626; }

        /* ── Tablet side-by-side: stats go horizontal ── */
        @media (max-width: 768px) {
          .bnr-stats { flex-direction: column; padding: 12px 14px; gap: 8px; }
          .bnr-info { padding: 36px 16px 14px; }
          .bnr-name { font-size: 14px; }
        }

        /* ── Mobile: full width ── */
        @media (max-width: 600px) {
          .bnr-card { border-radius: 16px; }
          .bnr-cover { height: 90px; }
          .bnr-info { padding: 36px 14px 12px; }
          .bnr-name { font-size: 15px; }
          .bnr-stats { padding: 12px 14px; gap: 8px; }
          /* Stats row horizontal on mobile to save vertical space */
          .bnr-stats { flex-direction: row; flex-wrap: wrap; }
          .bnr-stat { flex: 1; min-width: 0; }
        }

        @media (max-width: 380px) {
          .bnr-stats { flex-direction: column; }
          .bnr-stat { padding: 8px 10px; }
          .bnr-stat-label { font-size: 10px; }
          .bnr-stat-value { font-size: 12px; }
        }
      `}</style>
    </div>
  );
};

export default Banner;